import { linkBuilder } from '@noths/polaris-client-data-builders';

import { Review, ReviewPagination } from 'src/types';

const reviewDefaults: Readonly<Review> = {
  id: 1,
  rating: 3,
  date: '2021-04-28',
  comment: '',
  response: null,
};

export const reviewBuilder = (review?: Partial<Review>): Readonly<Review> => ({
  ...reviewDefaults,
  ...review,
});

const reviewPaginationDefaults: Readonly<ReviewPagination> = {
  totalEntries: 1,
  totalPages: 1,
  currentPage: 1,
  perPage: 1,
  links: [linkBuilder()],
};

export const reviewPaginationBuilder = (
  reviewPagination?: Partial<ReviewPagination>,
): Readonly<ReviewPagination> => ({
  ...reviewPaginationDefaults,
  ...reviewPagination,
});
